/**
 * Format a `triggeredBy` value (email/ObjectId/null) for the re-evaluation
 * feed attribution line. Email local-parts split on `.`/`_`/`-` and title-case
 * so `adam.jones@iuvotech.com` reads `Adam Jones`. Falls back to the raw
 * value when the input doesn't parse as an email, and to `null` when the
 * server didn't capture an actor.
 */
export function formatTriggeredBy(triggeredBy: string | null | undefined): string | null {
  if (!triggeredBy) return null
  const atIdx = triggeredBy.indexOf('@')
  if (atIdx <= 0) return triggeredBy
  const local = triggeredBy.slice(0, atIdx)
  const parts = local.split(/[._-]+/).filter(Boolean)
  if (parts.length === 0) return triggeredBy
  return parts
    .map(p => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
    .join(' ')
}
